import { SET_CREATORS } from './actionTypes';

export default (state = [], { type, payload }) => {
  switch (type) {
    case SET_CREATORS:
      return payload;
    default:
      return state;
  }
};
